import React from 'react'
import './RegistrationFees.css'
const RegistrationFees = () => {
    return (
        <div className='RegistrationFees'>
            <span className="heading">REGISTRATION <span>FEES</span></span>
            <table border="4">
                <thead>
                    <th style={{ background: '#333a38', color: 'white', textAlign: 'center', border: '2px solid white', fontWeight: '500' }}>
                        Category
                    </th>
                    <th style={{ background: '#333a38', color: 'white', textAlign: 'center', border: '2px solid white', fontWeight: '500' }}>For
                        India</th>
                    <th style={{ background: '#333a38', color: 'white', textAlign: 'center', border: '2px solid white', fontWeight: '500' }}>For
                        Other Countries</th>
                </thead>
                <tbody>
                   
                    <tr>
                        <td>Author(s) (IEEE Members)</td>
                        <td>INR 7000</td>
                        <td>USD 175</td>
                    </tr>
                     <tr>
                        <td>Author(s) (Non-IEEE Members)</td>
                        <td>INR 9000</td>
                        <td>USD 225</td>
                    </tr>

                    <tr>
                        <td>Invited Presentation</td>
                        <td>INR 6500</td>
                        <td>USD 150</td>
                    </tr>

                   

                   


                    <tr>
                        <td>Conference Attendee/Listener</td>
                        <td>INR 2500</td>
                        <td>USD 75</td>
                    </tr>


                   
                </tbody>
            </table>
        </div>
    )
}

export default RegistrationFees